<div class="content-carousel" >
  <div #virtualScroll class="virtual-scroll" track="horizontal">
    <div class="carousel-wrap">
      <ng-content></ng-content>
    </div>
  </div>
</div>
